export default __webpack_public_path__ + "static/media/UserGuide_en_US.0dcb2c74.pdf";